import { gdssid, gdsid, token, environment, cookie } from '@gaodun.com/gtools';
import axios, { AxiosRequestConfig } from 'axios';
import liveApi from '@/apis';
import { AutoLogin } from '@/apis/login';

declare const window: any;

// IE浏览器
export function isIE() {
    const result = !!window.ActiveXObject || 'ActiveXObject' in window;
    return result;
}

export function isStudentRoute() {
    const { hash } = window.location;
    const index = hash.indexOf('?');
    const route = hash.slice(0, index);
    return ['#/', '#/play'].includes(route);
}

// 全屏功能
export const requestFullScreen = (element: any) => {
    // @ts-ignore
    const requestMethod =
        element.requestFullscreen || element.webkitRequestFullscreen || element.mozRequestFullscreen || element.msRequestFullscreen;
    if (requestMethod) {
        requestMethod.call(element);
    } else if (typeof window.ActiveXObject !== 'undefined') {
        // for Internet Explorer
        const wscript = new window.ActiveXObject('WScript.Shell');
        if (wscript !== null) {
            wscript.SendKeys('{F11}');
        }
    }
};

// 退出全屏 判断浏览器种类
export const exitFull = () => {
    const docu: any = document;
    // @ts-ignore
    const exitMethod = docu.exitFullscreen || docu.webkitExitFullScreen || docu.mozCancleFullScreen || docu.webkitExitFullscreen;
    if (exitMethod) {
        exitMethod.call(document);
    } else if (typeof window.ActiveXObject !== 'undefined') {
        // for Internet Explorer
        const wscript = new window.ActiveXObject('WScript.Shell');
        if (wscript !== null) {
            wscript.SendKeys('{F11}');
        }
    }
};

// 判断全屏
export const checkFull = () => {
    // @ts-ignore
    let isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;
    if (isFull === undefined) isFull = false;
    return isFull;
};

/**
 * 获取url location hash param
 * @param {string} key
 */
export const querySearchParam = (key: string) => {
    const { hash } = window.location;
    const index = hash.indexOf('?') + 1;
    const paramsString = hash.substring(index);
    const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i');
    const r = paramsString.match(reg);
    if (r !== null) {
        return decodeURIComponent(r[2]);
    }
    return null;
};

/**
 * @description json取值 避免undefined报错
 * @param {*} file
 * @returns {*} promise
 */
export const getBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
};

/**
 * @description 获取c端用户token
 * @returns { string } accessToken
 */
export const getUserToken = async () => {
    if (isAssistant() || location.href.includes('selfTest')) {
        return await getAssistantToken();
    }
    // 学员端取gdssid
    const g = await gdssid.get();
    const accessToken = await token.getFronttoken({
        GDSSID: g,
        AppID: 130444,
    });
    if (accessToken && accessToken.info !== -1) {
        return accessToken;
    }
};

async function getAssistantToken() {
    const g = await gdsid.get();
    const accessToken = await token.getAdmintoken({
        GDSSID: g,
        AppID: 130444,
    });
    if (accessToken && accessToken.info !== -1) {
        return accessToken;
    }
}

/**
 * 获取访客token
 */
export const getVisitToken = async () => {
    const g = await gdssid.get();
    const visitorToken = await token.getVisitToken({
        GDSSID: g,
        AppID: 130444,
    });
    if (visitorToken && visitorToken.info !== -1) {
        return visitorToken;
    }
    return '';
};

export const getStorage = (key: string) => {
    const value = localStorage.getItem(key);
    if (value) {
        return value;
    }
    return '';
};

export const isAssistant = () => {
    const hash = window.location.hash.slice(0, window.location.hash.indexOf('?'));
    const result = hash.includes('assistant');
    return result;
};

// 网络请求配置项
export class AxiosConfig {
    config: AxiosRequestConfig;
    pathName: string;
    static instance: any;
    constructor() {
        this.config = {
            baseURL: environment.getApigateWay(),
            headers: {
                'X-Requested-Extend': querySearchParam('did'),
                'Content-Type': 'application/json',
            },
        };
        const hash = window.location.hash.slice(0, window.location.hash.indexOf('?'));
        this.pathName = hash.toLocaleLowerCase();
    }

    init(config: AxiosRequestConfig) {
        return new Promise(async resolve => {
            setAuthConfig(config);
            if (config.headers['Content-Type']) {
                this.config.headers['Content-Type'] = config.headers['Content-Type'];
            }
            // 避免重复计算
            if (this.config.headers.Authentication) {
                return resolve({ ...config, ...this.config });
            }
            // B端 or C端
            if (this.pathName.startsWith('#/b/') || this.pathName.startsWith('#/mcloud/')) {
                let userToken = '';
                if (isAssistant()) {
                    userToken = cookie.getCookie('b-Accesstoken');
                } else {
                    userToken = cookie.getCookie('Accesstoken') || querySearchParam('accessToken') || cookie.getCookie('accessAdmintoken');
                }
                if (!userToken) return resolve(this.config);
                this.config.baseURL = `https://${environment.getApiEnv()}mgateway.gaodunwangxiao.com`;
                this.config.headers['authorization'] = `${userToken}`;
                this.config.headers['Accesstoken'] = userToken;
                resolve({ ...config, ...this.config });
            } else if (this.pathName.startsWith('#/record') || this.pathName.startsWith('#/visit')) {
                const token = await getVisitToken();
                if (token) {
                    this.config.headers['Authentication'] = `Basic ${token}`;
                }
                resolve({ ...config, ...this.config });
            } else {
                const res = await getUserToken();
                if (res) {
                    this.config.headers['Authentication'] = `Basic ${res}`;
                }
                resolve({ ...config, ...this.config });
            }
        });
    }

    static getStance() {
        if (!this.instance) {
            this.instance = new AxiosConfig();
        }
        return this.instance;
    }
}

/**
 * 获取liveToken
 */
export const liveAuth = async () => {
    const roomId = querySearchParam('roomId');
    const { result } = await liveApi.getLiveToken(roomId);
    if (result) {
        localStorage.setItem('liveToken', result);
        return result;
    }
    return false;
};

/**
 * 请求接口鉴权设置
 */
export const setAuthConfig: (config: AxiosRequestConfig) => Promise<any> = async config => {
    // 无需鉴权的api
    if (config.url?.includes('live/getToken') || !config.url?.includes('glive2-cloud-gateway')) {
        return config;
    }
    const did = querySearchParam('did'); // appid
    if (did) {
        let liveToken = getStorage('liveToken');
        if (!liveToken) {
            const isAuth = await liveAuth();
            if (!isAuth) {
                return Promise.reject({
                    message: '没有进入直播间权限',
                    status: -1,
                });
            }
            liveToken = isAuth;
        }
        config.params = { ...config.params, auth: liveToken, timestamp: Math.ceil(new Date().getTime() / 1000) };
    }
};

export function formatTime(time: number) {
    const format = (num: number) => {
        if (num < 10) {
            return '0' + num;
        }
        return num;
    };
    const seconds = format(time % 60);
    const minutes = format(parseInt(`${time / 60}`) % 60);
    const hours = format(parseInt(`${time / 60 / 60}`));
    return `${hours}:${minutes}:${seconds}`;
}

export function formatDuration(time: number) {
    const format = (num: number) => {
        if (num < 10) {
            return '0' + num;
        }
        return num;
    };
    // const seconds = format(time % 60);
    const minutes = format(parseInt(`${time / 60}`) % 60);
    const hours = format(parseInt(`${time / 60 / 60}`));
    return `${hours}:${minutes}`;
}

// 滚动底部
export const onScrollBottom = (ele: Element | null) => {
    if (!ele) return;
    const scrollHeight = ele?.scrollHeight;
    if (ele && scrollHeight) {
        ele.scrollTop = scrollHeight;
    }
};

// 滚动距离超出元素可视区域高度
export function isScrollOverClientHeight(ele: Element | null): boolean {
    ele && console.log(ele.scrollHeight, ele.scrollTop, ele.clientHeight);
    return (ele && Math.round(ele.scrollHeight) - Math.round(ele.scrollTop) > Math.round(ele.clientHeight)) || false;
}

// 判断空对象
export function isEmptyObject(option: any) {
    if (Object.prototype.toString.call(option) !== '[object Object]') {
        throw new Error('there needs an object option');
    }
    return Object.keys(option).length === 0;
}

export function getUserName(name: string | undefined, maxLength: number) {
    if (!name) return '';
    return name.length > maxLength ? `${name.slice(0, maxLength)}...` : name;
}

/**
 * 生成客户端唯一ID
 * 结合设备信息和随机数生成稳定的唯一标识
 */
export const generateClientId = (): string => {
    const storageKey = 'client_unique_id';

    // 尝试从本地存储获取
    let clientId = getStorage(storageKey);

    if (!clientId) {
        // 生成新的客户端ID
        const timestamp = Date.now().toString(36);
        const random = Math.random().toString(36).substring(2, 8);
        const platform = navigator.platform || 'unknown';
        const userAgent = navigator.userAgent || 'unknown';

        // 简单的哈希算法
        let hash = 0;
        const combined = `${platform}-${userAgent}-${timestamp}-${random}`;
        for (let i = 0; i < combined.length; i++) {
            const char = combined.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // 转换为32位整数
        }

        // 生成16位唯一ID
        clientId = Math.abs(hash).toString(16).padStart(8, '0') + random + timestamp.substring(timestamp.length - 4);

        // 保存到本地存储
        try {
            localStorage.setItem(storageKey, clientId);
        } catch (error) {
            console.warn('保存客户端ID失败:', error);
        }

        console.log('生成新的客户端ID:', clientId);
    }

    return clientId;
};

/**
 * 获取客户端唯一ID
 * 如果不存在则自动生成
 */
export const getClientId = (): string => {
    return generateClientId();
};

/**
 * 清除客户端ID（用于测试）
 */
export const clearClientId = (): void => {
    try {
        localStorage.removeItem('client_unique_id');
        console.log('客户端ID已清除');
    } catch (error) {
        console.warn('清除客户端ID失败:', error);
    }
};

/**
 * 测试客户端ID（开发环境使用）
 * 在控制台显示当前客户端ID信息
 */
export const testClientId = (): void => {
    if (process.env.NODE_ENV === 'development') {
        const clientId = getClientId();
        console.log('=== 客户端ID测试信息 ===');
        console.log('当前客户端ID:', clientId);
        console.log('存储键名:', 'client_unique_id');
        console.log('本地存储值:', localStorage.getItem('client_unique_id'));
        console.log('=======================');
    }
};

// 生成uuid
export const getUuid = () => {
    let d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now();
    }
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
};
